export default "__VITE_ASSET__iAnLiXPd__"